module.exports = __webpack_public_path__ + "img/护理-2.2aaec54a.png";